// extracted by mini-css-extract-plugin
export var phone = "_29-0";
export var phoneDragging = "_29-1";